import React, { useEffect, useState } from "react"
import { NavLink, useLocation } from "react-router-dom"

import { callBackend1 } from "../../../api/Communication"
import {
  loadMenu,
  IMenuItem,
  IMenuData
} from "../../../containers/applicationSlice"
import LoginDialog from "../../../components/loginDialog"
import NavItem from "./NavItem"
import { ReactComponent as Logo } from "../../../img/ocs-logo.svg"
import PPRLogo from "../../../img/fraport-greece-logo.jpeg"
import { routeMap } from "./routeMap"
import { HandlingApp, PageId } from "../../../common/pageId"
import _ from "lodash"
import DownloadsBtn from "../../download/DownloadsBtn"
import DropdownButton from "../buttons/DropdownButton"
import PrivacyPolicy from "../../../documents/OCS_Privacy_Policy.pdf"
import ReleaseNotes from "../../../documents/OCS_Release_Notes.pdf"
import { PageContent } from "../../../common/pageText"
import { useAppDispatch, useAppSelector } from "../../../app/hooks"
import MenuBurger from "../../MenuBurger"

const NavBar: React.FC = () => {
  const [userMenu, setUserMenu] = useState(null)
  const dispatch = useAppDispatch()
  const { menu, userInfo, versionInfo } = useAppSelector(
    (state) => state["appReducer"]
  )

  const location = useLocation()

  useEffect(() => {
    // make sure we do not get menu before login state is determined
    if (userInfo?.loginName !== undefined) {
      doLoadMenu()
    }
    // eslint-disable-next-line
  }, [userInfo])

  useEffect(() => {
    setUserMenu(menu)
  }, [menu])

  const pageId = PageId.DefaultPage
  const isFRAPORTGRHandling =
    versionInfo.handlingApplication === HandlingApp.FRAPORTGR

  const doLoadMenu = async () => {
    try {
      const result = await callBackend1("getMenu", pageId, {})
      dispatch(loadMenu({ items: result.items, isAuth: result.isAuth }))
    } catch (error) {
      console.error(error.message)
    }
  }

  //Create navigation
  const getMenu = (userMenu: IMenuData) => {
    if (userMenu === null) {
      return null
    }
    return userMenu.items.map((item: IMenuItem, index) => {
      if (item === null) {
        return null
      }

      if (
        item.pageId === PageId.Login ||
        item.pageId === PageId.LogoutPage ||
        item.name === "Information" //TODO: Get Michael to remove from backend
      ) {
        return null
      }

      if (item.items === null || item.items.length === 0) {
        if (item.pageId === null) {
          return null
        }

        const isActive =
          location.pathname.toLowerCase() ===
          (routeMap[item.pageId] || "/" + item.pageId.toLowerCase())

        return (
          <NavItem key={index} className={isActive ? "active" : ""}>
            <NavLink
              to={routeMap[item.pageId] || "/" + _.camelCase(item.pageId)}
            >
              {item.name}
            </NavLink>
          </NavItem>
        )
      } else {
        const isActive = item.items.find(
          (mi) =>
            location.pathname.toLowerCase() ===
            (routeMap[mi.pageId] || "/" + mi.pageId?.toLowerCase())
        )
        return (
          <DropdownButton
            key={index}
            links={item.items.map((menuItem) => {
              return {
                onClick: () => setOpenNav(false),
                label: menuItem.name,
                route:
                  routeMap[menuItem.pageId] ||
                  "/" + _.camelCase(menuItem.pageId),
                className: isActive?.pageId === menuItem.pageId ? "active" : ""
              }
            })}
            className={"nav-item " + (isActive ? "active" : "")}
          >
            {item.name}
          </DropdownButton>
        )
      }
    })
  }

  const informationRoutes = [
    routeMap[PageId.About].toLowerCase(),
    routeMap[PageId.HowToApply].toLowerCase(),
    routeMap[PageId.Cookies].toLowerCase()
  ]

  const informationIsActive = informationRoutes.find(
    (r) => r === location.pathname.toLowerCase()
  )

  // Help menu
  let helpLinks = [
    {
      label: "Online Help",
      extRoute: process.env.REACT_APP_PUBLIC_URL + "/help"
    },
    {
      label: PageContent.contactUs,
      route: routeMap[PageId.ContactUs]
    },
    {
      label: "FAQ",
      route: routeMap[PageId.FAQS]
    },
    { label: "Release Notes", extRoute: ReleaseNotes },
    {
      label: "Open " + versionInfo.backupSiteName + " Site",
      extRoute: versionInfo.backupSiteUrl,
      className: "border-top"
    }
  ]

  // Help menu for PPR
  if (isFRAPORTGRHandling) {
    helpLinks = [
      {
        label: "Online Help",
        extRoute: process.env.REACT_APP_PUBLIC_URL + "/help/PPR_Manual.pdf"
      },
      {
        label: PageContent.contactUs,
        route: routeMap[PageId.ContactUs]
      }
    ]
  }
  const [openNav, setOpenNav] = useState(false)

  const onToggleMenu = () => {
    setOpenNav((openNav) => !openNav)
  }

  useEffect(() => {
    if (openNav) {
      document.body.style.overflow = "hidden"
    }
    return () => {
      document.body.style.overflow = "unset"
    }
  }, [openNav])
  return (
    <header className="ocs-main-header">
      <section className="ocs-main-header-container">
        <div className="brand-logo">
          <NavLink to="/" className="logo">
            {isFRAPORTGRHandling ? <img src={PPRLogo} alt="logo" /> : <Logo />}
          </NavLink>
        </div>
        <nav className={`${openNav ? "open-nav" : ""}`}>
          <MenuBurger onClick={onToggleMenu} />
          <ul className="ocs-nav-container">
            {getMenu(userMenu)}
            {!isFRAPORTGRHandling && (
              <DropdownButton
                links={[
                  {
                    label: "About Us",
                    route: routeMap[PageId.About],
                    className:
                      location.pathname.toLowerCase() ===
                      routeMap[PageId.About].toLowerCase()
                        ? "active"
                        : ""
                  },
                  {
                    label: "How to Apply",
                    route: routeMap[PageId.HowToApply],
                    className:
                      location.pathname.toLowerCase() ===
                      routeMap[PageId.HowToApply].toLowerCase()
                        ? "active"
                        : ""
                  },
                  {
                    label: "Privacy Policy",
                    extRoute: PrivacyPolicy
                  },
                  {
                    label: "Cookies",
                    route: routeMap[PageId.Cookies],
                    className:
                      location.pathname.toLowerCase() ===
                      routeMap[PageId.Cookies].toLowerCase()
                        ? "active"
                        : ""
                  }
                ]}
                className={"nav-item " + (informationIsActive ? "active" : "")}
              >
                Information
              </DropdownButton>
            )}
          </ul>
        </nav>
      </section>

      <section className="h-100p login-container d-flex align-items-end">
        {userInfo.authenticated && <DownloadsBtn />}
        <DropdownButton
          title="Help"
          links={helpLinks}
          className="navbar-dropdown"
        >
          Help
        </DropdownButton>
        <LoginDialog menu={userMenu ? userMenu.items : []} />
      </section>
      {versionInfo.siteName && (
        <p className="ocs-version-txt">{versionInfo.siteName}</p>
      )}
    </header>
  )
}

export default NavBar
